import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelDynamic as _vModelDynamic, withDirectives as _withDirectives, createBlock as _createBlock, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, withCtx as _withCtx, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = ["id", "aria-labelledby"]
const _hoisted_2 = { class: "offcanvas-header" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  type: "button",
  class: "btn-close text-reset",
  "data-bs-dismiss": "offcanvas",
  "aria-label": "Fechar filtros",
  title: "Fechar filtros",
  ref: "closeFilter"
}
const _hoisted_5 = { class: "offcanvas-body" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = ["for"]
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-3" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = ["type", "onUpdate:modelValue", "id"]
const _hoisted_12 = ["onUpdate:modelValue", "id"]
const _hoisted_13 = {
  key: 7,
  class: "form-check"
}
const _hoisted_14 = ["for"]
const _hoisted_15 = ["onUpdate:modelValue", "id"]
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = ["aria-label"]
const _hoisted_19 = ["id", "name", "onUpdate:modelValue", "value"]
const _hoisted_20 = ["for"]
const _hoisted_21 = { class: "mb-3" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-2" }
const _hoisted_24 = ["for"]
const _hoisted_25 = { class: "offcanvas-footer" }
const _hoisted_26 = { class: "d-flex justify-content-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownConsulte = _resolveComponent("DropDownConsulte")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_DropDownListMerTipoMaterial = _resolveComponent("DropDownListMerTipoMaterial")!
  const _component_DropDownListFornecedor = _resolveComponent("DropDownListFornecedor")!
  const _component_DropDownListEscola = _resolveComponent("DropDownListEscola")!
  const _component_DropDownListPcoProjeto = _resolveComponent("DropDownListPcoProjeto")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      role: "dialog",
      class: "offcanvas offcanvas-top",
      tabindex: "-1",
      ref: "offcanvasEl",
      id: _ctx.$props.idFilters,
      "aria-labelledby": `${_ctx.$props.idFilters}-titulo`,
      style: {"height":"75vh"}
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h4", {
          id: `${_ctx.$props.idFilters}-titulo`
        }, "Filtros", 8, _hoisted_3),
        _createElementVNode("button", _hoisted_4, null, 512)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterableColumns, (column) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "mb-3 col-sm-6 col-lg-6 col-lg-6",
              key: column.datafield
            }, [
              (column.filtertype != 'checkbox')
                ? (_openBlock(), _createElementBlock("label", {
                    key: 0,
                    for: column.datafield,
                    class: "form-label"
                  }, _toDisplayString(column.text), 9, _hoisted_7))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_DropDownConsulte, {
                    id: 'selectFilterExpression' + column.datafield,
                    "aria-label": `Tipo de comparação para ${column.text}`,
                    modelValue: _ctx.filterExpressionAux[column.datafield],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.filterExpressionAux[column.datafield]) = $event),
                    disabled: 
                    column.filtertype == 'autocomplete' ||
                    column.filtertype == 'merTipoMaterial' ||
                    column.filtertype == 'gesFornecedor' ||
                    column.filtertype == 'gesEscola' ||
                    column.filtertype == 'pcoProjeto' ||
                    column.filtertype == 'list' ||
                    column.filtertype == 'urlList' ||
                    column.filtertype == 'checkbox' ||
                    column.filtertype == 'radiobuttonlist'
                  ,
                    array: _ctx.operadoresDisponiveis(column.filtertype),
                    "row-label": "label",
                    "row-value": "value",
                    placeholder: ''
                  }, null, 8, ["id", "aria-label", "modelValue", "onUpdate:modelValue", "disabled", "array"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (
                    column.filtertype == 'text' ||
                    column.filtertype == 'number' ||
                    column.filtertype == 'date' ||
                    column.filtertype == 'text'
                  )
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 0,
                        type: column.filtertype,
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                        id: column.datafield,
                        class: "form-control"
                      }, null, 8, _hoisted_11)), [
                        [_vModelDynamic, _ctx.filterAux[column.datafield]]
                      ])
                    : _createCommentVNode("", true),
                  (column.filtertype == 'autocomplete' || column.filtertype == 'autoComplete')
                    ? (_openBlock(), _createBlock(_component_MultiSelect, {
                        key: 1,
                        modelValue: _ctx.filterAux[column.datafield],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                        mode: column.filtermode ? column.filtermode : 'single',
                        searchable: true,
                        options: _ctx.filtersData[column.datafield] ?? [],
                        "close-on-select": true,
                        "clear-on-select": false,
                        trackBy: column.filtertextfield,
                        valueProp: column.filtervaluefield,
                        object: false,
                        label: column.filtertextfield,
                        placeholder: "Selecione um item."
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "mode", "options", "trackBy", "valueProp", "label"]))
                    : _createCommentVNode("", true),
                  (column.filtertype == 'merTipoMaterial')
                    ? (_openBlock(), _createBlock(_component_DropDownListMerTipoMaterial, {
                        key: (_ctx.dataSource as any)?.merClassificacaoId,
                        modelValue: _ctx.filterAux[column.datafield],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                        "mer-classificacao-id": (_ctx.dataSource as any)?.merClassificacaoId
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "mer-classificacao-id"]))
                    : _createCommentVNode("", true),
                  (column.filtertype == 'gesFornecedor')
                    ? (_openBlock(), _createBlock(_component_DropDownListFornecedor, {
                        key: 3,
                        modelValue: _ctx.filterAux[column.datafield],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (column.filtertype == 'gesEscola')
                    ? (_openBlock(), _createBlock(_component_DropDownListEscola, {
                        key: 4,
                        modelValue: _ctx.filterAux[column.datafield],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event)
                      }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                    : _createCommentVNode("", true),
                  (column.filtertype == 'pcoProjeto')
                    ? (_openBlock(), _createBlock(_component_DropDownListPcoProjeto, {
                        key: `pcoProjetoFiltro_${_ctx.filterAux.gesEscolaId ?? 0}`,
                        modelValue: _ctx.filterAux[column.datafield],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                        "ges-escola-id": _ctx.obterGesEscolaIdFiltro() ?? 0
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "ges-escola-id"]))
                    : _createCommentVNode("", true),
                  (!column.filtertype)
                    ? _withDirectives((_openBlock(), _createElementBlock("input", {
                        key: 6,
                        type: "text",
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                        id: column.datafield,
                        class: "form-control"
                      }, null, 8, _hoisted_12)), [
                        [_vModelText, _ctx.filterAux[column.datafield]]
                      ])
                    : _createCommentVNode("", true),
                  (column.filtertype == 'checkbox')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (column.filtertype == 'checkbox')
                          ? (_openBlock(), _createElementBlock("label", {
                              key: 0,
                              for: column.datafield,
                              class: "form-check-label"
                            }, _toDisplayString(column.text), 9, _hoisted_14))
                          : _createCommentVNode("", true),
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                          id: column.datafield,
                          class: "form-check-input"
                        }, null, 8, _hoisted_15), [
                          [_vModelCheckbox, _ctx.filterAux[column.datafield]]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (column.filtertype == 'urlList' || column.filtertype == 'urlList')
                    ? (_openBlock(), _createBlock(_component_DropDownConsulte, {
                        key: 8,
                        modelValue: _ctx.filterAux[column.datafield],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                        "aria-label": `Filtrar por ${column.text}`,
                        placeholder: ''
                      }, {
                        default: _withCtx(() => [
                          _cache[3] || (_cache[3] = _createElementVNode("option", { value: "" }, null, -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtersData[column.datafield], (data) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: data[column.filtertextfield!],
                              value: data[column.filtervaluefield!]
                            }, _toDisplayString(data[column.filtertextfield!]), 9, _hoisted_16))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "aria-label"]))
                    : _createCommentVNode("", true),
                  (column.filtertype == 'list')
                    ? (_openBlock(), _createBlock(_component_DropDownConsulte, {
                        key: 9,
                        modelValue: _ctx.filterAux[column.datafield],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                        "aria-label": `Filtrar por ${column.text}`,
                        placeholder: ''
                      }, {
                        default: _withCtx(() => [
                          _cache[4] || (_cache[4] = _createElementVNode("option", { value: "" }, null, -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtersData[column.datafield], (data) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: column.filtertextfield ? data[column.filtertextfield] : data,
                              value: column.filtervaluefield ? data[column.filtervaluefield] : data
                            }, _toDisplayString(column.filtertextfield ? data[column.filtertextfield] : data), 9, _hoisted_17))
                          }), 128))
                        ]),
                        _: 2
                      }, 1032, ["modelValue", "onUpdate:modelValue", "aria-label"]))
                    : _createCommentVNode("", true),
                  (column.filtertype == 'radiobuttonlist')
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 10,
                        class: "d-flex flex-wrap gap-3",
                        role: "radiogroup",
                        "aria-label": `Filtrar por ${column.text}`
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filtersData[column.datafield], (data) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "form-check",
                            key: column.filtervaluefield ? data[column.filtervaluefield] : data
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              class: "form-check-input",
                              type: "radio",
                              id: `${column.datafield}_${column.filtervaluefield ? data[column.filtervaluefield] : data}`,
                              name: `radioFilter_${column.datafield}`,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.filterAux[column.datafield]) = $event),
                              value: column.filtervaluefield ? data[column.filtervaluefield] : data
                            }, null, 8, _hoisted_19), [
                              [_vModelRadio, _ctx.filterAux[column.datafield]]
                            ]),
                            _createElementVNode("label", {
                              class: "form-check-label",
                              for: `${column.datafield}_${column.filtervaluefield ? data[column.filtervaluefield] : data}`
                            }, _toDisplayString(column.filtertextfield ? data[column.filtertextfield] : data), 9, _hoisted_20)
                          ]))
                        }), 128))
                      ], 8, _hoisted_18))
                    : _createCommentVNode("", true)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", {
                for: `${_ctx.$props.idFilters}-registros-por-pagina`,
                class: "form-label"
              }, " Registros por Página ", 8, _hoisted_24),
              _createVNode(_component_DropDownConsulte, {
                id: `${_ctx.$props.idFilters}-registros-por-pagina`,
                modelValue: _ctx.rowsPerPage,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.rowsPerPage) = $event)),
                busca: false,
                placeholder: ''
              }, {
                default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("option", null, "5", -1),
                  _createElementVNode("option", null, "10", -1),
                  _createElementVNode("option", null, "15", -1),
                  _createElementVNode("option", null, "20", -1),
                  _createElementVNode("option", null, "25", -1),
                  _createElementVNode("option", null, "30", -1),
                  _createElementVNode("option", null, "35", -1),
                  _createElementVNode("option", null, "40", -1),
                  _createElementVNode("option", null, "45", -1),
                  _createElementVNode("option", null, "50", -1),
                  _createElementVNode("option", null, "55", -1),
                  _createElementVNode("option", null, "60", -1),
                  _createElementVNode("option", null, "65", -1),
                  _createElementVNode("option", null, "70", -1),
                  _createElementVNode("option", null, "75", -1),
                  _createElementVNode("option", null, "80", -1),
                  _createElementVNode("option", null, "85", -1),
                  _createElementVNode("option", null, "90", -1),
                  _createElementVNode("option", null, "95", -1),
                  _createElementVNode("option", null, "100", -1)
                ]))]),
                _: 1
              }, 8, ["id", "modelValue"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_25, [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("button", {
            class: "btn btn-outline-danger me-1",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearFilters && _ctx.clearFilters(...args)))
          }, "Limpar"),
          _createElementVNode("button", {
            class: "btn btn-primary",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.filter && _ctx.filter(...args)))
          }, "Filtrar")
        ])
      ])
    ], 8, _hoisted_1)
  ]))
}